<template>
    <div v-if="items.length > 0 || expired.length > 0" class="MigratedComplianceSummary">
        <p v-if="items.length > 0" class="MigratedComplianceSummary__paragraph">
            <strong class="MigratedComplianceSummary__lead">{{ lead }}</strong>
            {{ names(items) }}. The entity won’t be engaged for these until near expiration.
        </p>
        <p v-if="expired.length > 0" class="MigratedComplianceSummary__paragraph">
            {{ expiredNotice }}
        </p>
    </div>
</template>

<style lang="scss">
    .MigratedComplianceSummary {
        background: var(--eidWarningYellow-10);
        border: 1px solid var(--eidWarningYellow-50);
        border-radius: 8px;
        color: var(--eidQualityBlack);
        font-size: var(--text-small-size, 13px);
        line-height: 1.5;
        padding: 10px 14px;

        &__paragraph {
            margin: 0;
        }

        &__paragraph + &__paragraph {
            margin-top: 6px;
        }

        &__lead {
            font-weight: 600;
        }
    }
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { MigratedRequirement } from './migratedCompliance';

    export default defineComponent({
        name: 'MigratedComplianceSummary',
        props: {
            // Dates of today or later, which saving marks compliant.
            items: {
                type: Array as PropType<MigratedRequirement[]>,
                default: (): MigratedRequirement[] => [],
            },
            // Dates that have already passed.
            expired: {
                type: Array as PropType<MigratedRequirement[]>,
                default: (): MigratedRequirement[] => [],
            },
        },
        computed: {
            lead(): string {
                const noun = this.items.length === 1 ? 'requirement' : 'requirements';

                return `On save, ${this.items.length} ${noun} will be marked compliant:`;
            },
            expiredNotice(): string {
                const one = this.expired.length === 1;
                const dates = this.expired.map((item) => `${item.name} (${item.formattedDate})`).join(', ');

                return `The ${one ? 'date' : 'dates'} for ${dates} ${one ? 'has' : 'have'} already passed, `
                    + `so Evident will still request ${one ? 'a document' : 'documents'} from the entity.`;
            },
        },
        methods: {
            names(requirements: MigratedRequirement[]): string {
                return requirements.map((item) => `${item.name} (until ${item.formattedDate})`).join(', ');
            },
        },
    });
</script>
